/* eslint-disable max-lines-per-function */
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import {
  getWiederholungStringFromTerminWiederholung,
  TerminWiederholung,
} from '@/domain/termine/shared/types/TerminWiederholung';
import { useDrawerSelection } from '@/domain/termine/features/UpdateTermin/Mobile/hooks/useDrawerSelection';

interface RepetitionIntervalDrawerProps {
  value: TerminWiederholung;
  onChange: (value: TerminWiederholung) => void;
}

export function RepetitionIntervalDrawer({
  value,
  onChange,
}: RepetitionIntervalDrawerProps) {
  const { t } = useTranslation();
  const { localSelection, handleOpenChange, handleSelect, handleConfirm } =
    useDrawerSelection<TerminWiederholung>(value, onChange);

  return (
    <Drawer onOpenChange={handleOpenChange}>
      <DrawerTrigger asChild>
        <Button variant="outline-secondary" className="w-full justify-between">
          <span className="text-sm">
            {getWiederholungStringFromTerminWiederholung(localSelection)}
          </span>
          <FontAwesomeIcon icon={faChevronDown} className="text-neutrals-400" />
        </Button>
      </DrawerTrigger>
      <DrawerContent className="flex flex-col">
        <DrawerHeader className="shrink-0">
          <DrawerTitle className="text-sm text-center text-neutrals-900 font-semibold">
            {t('domain.termine.repeat')}
          </DrawerTitle>
          <DrawerDescription className="sr-only">
            {t('domain.termine.repeat')}
          </DrawerDescription>
        </DrawerHeader>
        <ScrollArea className="flex-1 px-4" data-vaul-no-drag>
          <div className="space-y-0">
            {Object.values(TerminWiederholung).map((enumValue, idx) => {
              const isSelected = localSelection === enumValue;
              return (
                <div key={enumValue}>
                  <Button
                    variant="ghost"
                    aria-selected={isSelected}
                    onClick={() => handleSelect(enumValue)}
                    className="w-full justify-between">
                    <span className="text-sm font-medium">
                      {getWiederholungStringFromTerminWiederholung(enumValue)}
                    </span>
                    {isSelected && (
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="text-primary-blue-600"
                      />
                    )}
                  </Button>
                  {idx < Object.values(TerminWiederholung).length - 1 && (
                    <div className="border-b border-neutrals-300" />
                  )}
                </div>
              );
            })}
          </div>
        </ScrollArea>
        <div className="p-4 shrink-0">
          <DrawerClose asChild>
            <Button className="w-full" size="lg" onClick={handleConfirm}>
              {t('domain.termine.form.fertig')}
            </Button>
          </DrawerClose>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
